import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleConfronto() {
  return <ArticleLayout article={articleContents['itaobuy-confronto']} />;
}